/**
 * 繁体中文
 */
export default {
  header: {
    lang: '簡繁切換',
    app: 'APP下載',
    about: '關於我們'
  },
  footer: {
    youth: '青少年安全上網',
    declare: '免責聲明',
    copyright: ' 蘇州馳聲信息科技有限公司 All Rights Reserved.',
    icp: '蘇ICP備14027754號-4',
    browser360: '下載360極速瀏覽器',
    browserqq: '下載QQ瀏覽器'
  },
  Login: {
    register: {
      title: '註冊學生帳號',
      phoneNumber: '手機號',
      captcha: '圖形驗證碼',
      captchaPh: '請輸入圖形驗證碼',
      changeOne: '換一個',
      phoneCode: '手機驗證碼',
      phoneCodePh: '請輸入手機驗證碼',
      getCode: '獲取驗證碼',
      password: '密碼',
      passwordPh: '請輸入密碼',
      certifyPassword: '確認密碼',
      newPasswordPh: '請再次輸入密碼',
      accept: '我已閱讀並接受',
      agreement: '《用戶服務協議》',
      rMsg: '下一步',
      haveOne: '已有帳號?',
      rightNow: '立即登錄',
      error: {
        phoneError: '請輸入11位手機號碼',
        phoneCodeError: '手機驗證碼不正確',
        captchaError: '請輸入4位圖形驗證碼',
        pwdEmpty: '密碼不能爲空',
        pwdInconsistent: '兩次密碼輸入不一致'
      }
    },
    loginBody: {
      identity: ['學生', '老師', '家長', '教研'],
      tidentity: ['教師', '教研'],
      login: '登錄',
      rememberPass: '記住密碼',
      forgetPass: '忘記密碼',
      downloadQR: '掃碼下載APP',
      register: '立即註冊',
      downloadByPhone: '手機掃碼下載',
      studentMobile: '學生移動端',
      teacherMobile: '老師移動端'
    },
    Activation: {
      title: '歡迎使用馳聲聽說在線，請激活賬號',
      requiredPh: '請輸入激活碼',
      save: '激活賬號',
      saveing: '正在驗證',
      preject: '完善個人信息'
    },
    PerfectInfo: {
      title: '請完善個人信息',
      attention: '必填信息(*)提交後不可更改，請謹慎操作！',
      schoolMsg: '若下拉菜單中沒有找到你的學校，請聯繫老師',
      name: '姓名',
      namePh: '請填寫真實姓名',
      sex: '性別：',
      sexDefault: '男',
      sexOther: '女',
      area: '地區',
      school: '學校',
      schoolPh: '請選擇所在學校',
      categroy: '年級',
      categroyPh: '請選擇所在年級',
      class: '班級',
      classPh: '請選擇所在班級',
      save: '保存'
    },
    edit: {
      title: '請修改個人信息',
    },
    perfect: {
      title: '註冊成功，請完善個人信息',
      name: '姓名：',
      namePh: '請填寫你的身份證或戶口本上的姓名',
      sex: '性別：',
      sexDefault: '男',
      sexOther: '女',
      idNumber: '身份證',
      idNumberPh: '請正確輸入15位或18位身份證號碼',
      area: '所在地區：',
      school: '所在學校：',
      other: '其他',
      schoolMsg: '若下拉菜單中沒有找到你的學校，請在“其他”框輸入學校名稱',
      schoolPh: '請輸入學校名稱',
      categroy: '所在年級：',
      class: '所在班級：',
      teacher: '輔導老師：',
      teacherPh: '請輸入輔導老師名稱',
      teacherPhone: '老師電話：',
      teacherPhonePh: '請輸入輔導老師電話',
      attention: '必填信息(*)提交後不可更改，請謹慎操作！',
      schoolKey: '關鍵字搜索學校',
      save: '保存',
      error: {
        stuNameErrMsg: '學生名字不能為空',
        idNumberErrMsg: '身份證格式不正確',
        teaNameErrMsg: '老師姓名不能為空',
        teaNumberErrMsg: '輔導老師號碼格式不正確',
        schoolErrMsg: '請選擇學校',
        categoryErrMsg: '請選擇所在年級',
        classErrMsg: '請選擇所在班級',
        areaErrMsg: '請選擇省市區'
      }
    },
    findPwd: {
      title: '找回密碼',
      step: ['確認賬號', '修改密碼', '完成'],
      phone: '手機號',
      phonePH: '請輸入手機號',
      verify: '驗證碼',
      verifyPH: '請輸入手機驗證碼',
      verifyBtn: '獲取驗證碼',
      newPwd: '設置新密碼',
      newPwdPH: '請輸入請密碼',
      newPwd2: '再次輸入新密碼',
      newPwdPH2: '請輸入新密碼',
      next: '下一步',
      relogin: '重新登錄',
      success: '密碼修改成功',
      tips: '溫馨提示：系統僅支持已綁定手機號碼的賬號，找回密碼',
      loginin: '進入學生端',
      error: {
        phoneLength: '請輸入11位手機號碼',
        verifyEmpty: '驗證碼不能爲空',
        unregister: '該手機號未注冊',
        verifyErr: '驗證碼錯誤',
        pwdInconsistent: '密碼設置不一致',
        pwdEmpty: '密碼不能爲空'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/i18n/tw.js